var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKembaliIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 20,
    viewBox: "0 0 10 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33038 19.9198C8.22445 19.9204 8.11943 19.9001 8.02136 19.86C7.92328 19.8199 7.83408 19.7609 7.75887 19.6863L1.18242 13.1099C0.807611 12.736 0.51024 12.2919 0.30734 11.8029C0.104441 11.3139 0 10.7897 0 10.2604C0 9.73096 0.104441 9.20677 0.30734 8.7178C0.51024 8.22883 0.807611 7.78469 1.18242 7.41083L7.75887 0.834385C7.83392 0.759333 7.92302 0.699798 8.02108 0.65918C8.11914 0.618562 8.22424 0.597656 8.33038 0.597656C8.43652 0.597656 8.54162 0.618562 8.63968 0.65918C8.73774 0.699798 8.82684 0.759333 8.9019 0.834385C8.97695 0.909438 9.03648 0.998538 9.0771 1.0966C9.11772 1.19466 9.13863 1.29976 9.13863 1.4059C9.13863 1.51204 9.11772 1.61714 9.0771 1.7152C9.03648 1.81326 8.97695 1.90236 8.9019 1.97741L2.32545 8.55386C1.87323 9.00664 1.61922 9.62041 1.61922 10.2604C1.61922 10.9003 1.87323 11.5141 2.32545 11.9668L8.9019 18.5433C8.97734 18.6181 9.03723 18.7071 9.07809 18.8052C9.11896 18.9033 9.14 19.0085 9.14 19.1148C9.14 19.2211 9.11896 19.3263 9.07809 19.4244C9.03723 19.5225 8.97734 19.6115 8.9019 19.6863C8.82668 19.7609 8.73748 19.8199 8.63941 19.86C8.54134 19.9001 8.43632 19.9204 8.33038 19.9198Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKembaliIc);
export default __webpack_public_path__ + "static/media/kembali_ic.fc7b76b5c259d0217e8acad170fcbdcf.svg";
export { ForwardRef as ReactComponent };